import { LoadingView } from '../../../../components/LoadingView';
import { Table } from '../../../../components/Table';
import { TableEmptyState } from '../../../../components/TableEmptyState';
import { useAdNetworksQuery } from '../../../../features/insights/useAdNetworksQuery';
import { useDispatchTrackEventWithLocation } from '../../../../services/tracking/hooks/useDispatchTrackEventWithLocation';
import { AdNetworksTableRow } from '../AdNetworksTableRow';

const AD_NETWORKS_TABLE_HEADER_CONFIG = [
  { translateKey: 'company.ad-networks.table.heading' },
  { translateKey: 'company.ad-networks.table.visits', width: '80px' },
  { translateKey: 'company.ad-networks.table.change', width: '80px' },
];

export const AdNetworksTable = () => {
  const { data, isLoading } = useAdNetworksQuery();
  const dispatchTrackEventWithLocation = useDispatchTrackEventWithLocation();

  const onPageChange = (page: number) => {
    dispatchTrackEventWithLocation('ad networks', 'change page', `ad networks/${data?.adNetworks.length || 0}/${page}`);
  };

  if (isLoading) {
    return <LoadingView />;
  }
  if (data?.adNetworks.length === 0) {
    return <TableEmptyState view="noResults" />;
  }
  return (
    <Table
      keyProperty="id"
      data={data?.adNetworks || []}
      headerConfig={AD_NETWORKS_TABLE_HEADER_CONFIG}
      RowComponent={AdNetworksTableRow}
      onPageChange={onPageChange}
    />
  );
};
